"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(value, suffix) {
    return value.substr(-suffix.length) === suffix;
}
exports.default = default_1;
//# sourceMappingURL=endsWith.js.map